export default (theme) => ({
    overlay: {
        zIndex: 1601,
    },
    table: {
        marginTop: 16,
        marginBottom: 20,
    },
    section: {
        '& > :first-child': {
            marginTop: 12,
        },
    },
    loader: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    row: {
        display: 'flex',
        height: 'auto',
        minHeight: '32px !important',
        wordBreak: 'break-word',
        alignItems: 'flex-start',
        padding: '4px 16px',
        borderRight: `1px solid ${theme.colors.grey[100]}`,
        borderLeft: `1px solid ${theme.colors.grey[100]}`,
        borderBottom: `1px solid ${theme.colors.grey[100]}`,

        '& > div': {
            marginTop: 6,
        },
        '& > div:nth-child(1)': {
            flex: 1,
            maxWidth: 150,
            marginRight: 30,
        },
        '& > div:nth-child(2)': {
            flex: 2,
            maxWidth: '320px',
        },
        '& > div:nth-child(3)': {
            flex: 0,
            visibility: 'hidden',
            marginRight: 6,
        },
        '&:hover': {
            '& > div:nth-child(3)': {
                visibility: 'visible',
            },
        },
    },
    clickableRow: {
        '&:hover': {
            backgroundColor: `${theme.colors.semantic.infoCustom50}33`,
        },
    },
    clickableStar: {
        cursor: 'pointer',
    },
    featured: {
        visibility: 'visible !important',
    },
    lock: {
        marginRight: 4,
        visibility: 'visible !important',
    },
    disabled: {
        pointerEvents: 'none',
        '& svg path': {
            fill: theme.colors.grey[200],
        },
    },
    featuredCell: {
        display: 'inline-flex',
    },
    emptySearchContainer: {
        marginTop: '60px !important',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
    },
    emptySearchIcon: {
        width: 80,
    },
});
